<template lang="pug">
  .pagination(v-if='pages > 1')
    router-link(:to="computeRoute(1)", v-if="currentPage > 1") #[chevron-double-left-icon]
    router-link(:to="computeRoute(currentPage - 1)", v-if="currentPage > 1") Prev
    router-link(:to="computeRoute(currentPage - 2)", v-if="currentPage - 2 > 0") {{ currentPage - 2 }}
    router-link(:to="computeRoute(currentPage - 1)", v-if="currentPage - 1 > 0") {{ currentPage - 1 }}
    router-link(:to="computeRoute(currentPage)").active {{ currentPage }}
    router-link(:to="computeRoute(currentPage + 1)",
      v-if="currentPage + 1 <= pages") {{ currentPage + 1 }}
    router-link(:to="computeRoute(currentPage + 2)",
      v-if="currentPage + 2 <= pages") {{ currentPage + 2 }}
    router-link(:to="computeRoute(currentPage + 1)", v-if="currentPage < pages") Next
    router-link(:to="computeRoute(pages)", v-if="currentPage < pages") #[chevron-double-right-icon]
</template>

<script>
import ChevronDoubleLeftIcon from 'vue-material-design-icons/ChevronDoubleLeft.vue';
import ChevronDoubleRightIcon from 'vue-material-design-icons/ChevronDoubleRight.vue';

export default {
  name: 'Pagination',
  components: {
    ChevronDoubleLeftIcon,
    ChevronDoubleRightIcon,
  },
  props: [
    'page',
    'pages',
    'uri',
  ],
  methods: {
    computeRoute(page) {
      if (this.uri) {
        return this.uri + page;
      }

      const { fullPath } = this.$route;
      if (fullPath.includes('page=')) {
        return fullPath.replace(/page=([0-9]*)/g, `page=${page}`);
      }

      return `${fullPath}${fullPath.includes('?') ? '&' : '?'}page=${page}`;
    },
  },
  computed: {
    currentPage() {
      return parseInt(this.page, 10);
    },
  },
};
</script>

<style lang="scss">
@import '@/style/definitions';

.pagination {
  padding: 16px;
  text-align: center;

  a {
    background: $gray;
    color: $color-fg;
    text-decoration: none;
    border-radius: 2px;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    line-height: 26px;
    margin: 1px;
    padding: 0 10px;
    font-size: 11px;
    text-transform: uppercase;
    font-weight: 700;

    &.active {
      background: $color-fg;
      color: $dark-gray;
    }

    svg {
      fill: $color-fg;
      width: 18px;
      height: 18px;
      vertical-align: middle;
      top: -2px;
      position: relative;
    }
  }
}
</style>
